import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BitcoinChart = _resolveComponent("BitcoinChart")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_EthereumChart = _resolveComponent("EthereumChart")!
  const _component_SolanaChart = _resolveComponent("SolanaChart")!
  const _component_BinanceChart = _resolveComponent("BinanceChart")!
  const _component_CardanoChart = _resolveComponent("CardanoChart")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex flex-wrap gap-2 justify-content-between mb-4\"><div><h3 class=\"mb-0\">Cryptocurrency Watch List</h3></div><div><div class=\"cryptocurrency-controller d-flex gap-1\"><div class=\"controller-icon prev\"><i class=\"ri-arrow-left-s-line\"></i></div><div class=\"controller-icon next\"><i class=\"ri-arrow-right-s-line\"></i></div></div></div></div>", 1)),
    _createVNode(_component_Swiper, {
      slidesPerView: 1,
      spaceBetween: 25,
      centeredSlides: false,
      preventClicks: true,
      loop: true,
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        prevEl: '.prev',
        nextEl: '.next',
      },
      pagination: {
        el: '.swiper-pagination-top-selling',
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
        1199: {
          slidesPerView: 3,
        },
        1440: {
          slidesPerView: 4,
        },
        1600: {
          slidesPerView: 4,
        },
      },
      modules: _ctx.modules,
      class: "cryptocurrency-slide"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SwiperSlide, null, {
          default: _withCtx(() => [
            _createVNode(_component_BitcoinChart)
          ]),
          _: 1
        }),
        _createVNode(_component_SwiperSlide, null, {
          default: _withCtx(() => [
            _createVNode(_component_EthereumChart)
          ]),
          _: 1
        }),
        _createVNode(_component_SwiperSlide, null, {
          default: _withCtx(() => [
            _createVNode(_component_SolanaChart)
          ]),
          _: 1
        }),
        _createVNode(_component_SwiperSlide, null, {
          default: _withCtx(() => [
            _createVNode(_component_BinanceChart)
          ]),
          _: 1
        }),
        _createVNode(_component_SwiperSlide, null, {
          default: _withCtx(() => [
            _createVNode(_component_CardanoChart)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modules"])
  ]))
}